// extracted by mini-css-extract-plugin
export default {"content":"recovery-notice_content__oCKa4","message":"recovery-notice_message__OGM3e","action":"recovery-notice_action__3QERg"};